import React from 'react';

import { CardBottom, CardMedia, CardName, CardPrices, CardTop, type TokenCardProps } from '@pkg/components';

import { CollectionChainType } from '@app/client';

import { CardInside, Wrapper } from './styles';

export const TokenCard = ({
    item,
    yatPageItem,
    groupItem,
    cardSize,
    chain = CollectionChainType.Ethereum,
    listPriceData,
    hideCollectionData,
    isCollectionTile = false,
    ...rest
}: TokenCardProps) => {
    const { image, contract, tokenId, rarityRank, media, lastBuy, lastSell } = item || {};
    const { activity_date } = yatPageItem || groupItem?.item || {};
    const { primary_yat, twitter } = groupItem?.owner || {};

    const NFTItem = groupItem?.item?.item_type?.Nft || yatPageItem?.item_type?.Nft || {};
    const commonItems = item || NFTItem;
    const { name } = commonItems || {};
    const {
        image: image_url,
        animation_url,
        contract_address,
        token_id,
        collection_name,
        collection_image,
        slug,
    } = NFTItem || {};

    const lastBuyValue = lastBuy?.value;
    const lastSellValue = lastSell?.value;

    return (
        <Wrapper>
            <CardInside $cardSize={cardSize} $height={rest.height}>
                {cardSize !== 'small' && (
                    <CardTop
                        owner_yat={primary_yat}
                        owner_twitter={twitter}
                        activity_date={activity_date}
                        cardSize={cardSize}
                    />
                )}

                <CardMedia
                    image_url={image || image_url}
                    contract={contract || contract_address}
                    animation_url={media || animation_url}
                    token_id={tokenId || token_id}
                    chain={chain}
                    rarity_rank={rarityRank}
                    cardSize={cardSize}
                />

                <CardName
                    chain={chain}
                    name={name || tokenId || token_id}
                    collection_name={collection_name}
                    collection_image={collection_image}
                    collection_slug={slug}
                    contract={contract || contract_address}
                    token_id={tokenId || token_id}
                    cardSize={cardSize}
                    hideCollectionData={hideCollectionData}
                />
                {lastBuyValue || lastSellValue ? (
                    <CardPrices
                        list_price={rest.list_price}
                        last_buy={lastBuyValue}
                        last_sell={lastSellValue}
                        cardSize={cardSize}
                        chain={chain}
                        listPriceData={listPriceData}
                    />
                ) : undefined}
                <CardBottom
                    chain={chain || CollectionChainType.Ethereum}
                    contract={contract || contract_address}
                    token_id={tokenId || token_id}
                    collection_slug={slug}
                    isCollectionTile={isCollectionTile}
                />
            </CardInside>
        </Wrapper>
    );
};
